import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import React from 'react';
import { useCreate, useNotify } from 'react-admin';

interface ContributorPopupProps {
  open: boolean;
  onClose: ()=> void;
  onSave: (contributorId: string)=> void;
}

function AlbumContributorCreate({ open, onClose, onSave }: ContributorPopupProps): React.ReactElement {
  const [name, setName] = React.useState('');
  const [create, { isLoading }] = useCreate();
  const notify = useNotify();

  const handleSave = async () => {
    if (!name.trim()) {
      notify('Contributor name is required', { type: 'error' });
      return;
    }

    await create(
      'contributors',
      { data: { Name: name.trim() } },
      {
        onSuccess: (data) => {
          onSave(data.id);
        },
      },
    );
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add New Contributor</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          label='Contributor Name'
          type='text'
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={isLoading}
          onKeyDown={async (e) => {
            if (e.key === 'Enter') {
              await handleSave();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>Cancel</Button>
        <Button
          onClick={handleSave} variant='contained'
          disabled={isLoading}
        >
          {isLoading ? 'Adding...' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AlbumContributorCreate;
